/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_ADMINISTRACAO_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterUnidadesProjetosAcoesPorDotacao(dotacaoId) {
        return axiosJwt
            .get(`${api}/rm/unidades/dotacao/${dotacaoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidadesProjetosAcoesPorDotacao2() {
        return axiosJwt
            .get(`${api}/rm/unidades/dotacao`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
